import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { analyticsDifareApi } from '../api/analytics-difare.api'
import type {
  ConfiguracionAnalyticsDifareUpdateInput,
  DependientesFiltro,
  TestConnectionInput,
} from '../types'

const KEYS = {
  all: ['analytics-difare'] as const,
  config: () => [...KEYS.all, 'config'] as const,
  overview: () => [...KEYS.all, 'overview'] as const,
  visitadores: () => [...KEYS.all, 'visitadores'] as const,
  quizzes: () => [...KEYS.all, 'quizzes'] as const,
  puntosVenta: () => [...KEYS.all, 'puntos-venta'] as const,
  fases: () => [...KEYS.all, 'fases'] as const,
  dependientes: (filtro: DependientesFiltro) => [...KEYS.all, 'dependientes', filtro] as const,
  trivias: (fase?: number) => [...KEYS.all, 'trivias', fase ?? 'todas'] as const,
}

export function useConfiguracionAnalyticsDifare() {
  return useQuery({
    queryKey: KEYS.config(),
    queryFn: () => analyticsDifareApi.getConfiguracion(),
  })
}

export function useGuardarConfiguracionAnalyticsDifare() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (payload: ConfiguracionAnalyticsDifareUpdateInput) =>
      analyticsDifareApi.saveConfiguracion(payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEYS.config() })
    },
  })
}

export function useTestConnectionAnalyticsDifare() {
  return useMutation({
    mutationFn: (payload?: TestConnectionInput) => analyticsDifareApi.testConnection(payload),
  })
}

export function useOverviewAnalyticsDifare() {
  return useQuery({
    queryKey: KEYS.overview(),
    queryFn: () => analyticsDifareApi.getOverview(),
  })
}

export function useVisitadoresAnalyticsDifare() {
  return useQuery({
    queryKey: KEYS.visitadores(),
    queryFn: () => analyticsDifareApi.getVisitadores(),
  })
}

export function useQuizzesAnalyticsDifare() {
  return useQuery({
    queryKey: KEYS.quizzes(),
    queryFn: () => analyticsDifareApi.getQuizzes(),
  })
}

export function usePuntosVentaAnalyticsDifare() {
  return useQuery({
    queryKey: KEYS.puntosVenta(),
    queryFn: () => analyticsDifareApi.getPuntosVenta(),
  })
}

export function useFasesAnalyticsDifare() {
  return useQuery({
    queryKey: KEYS.fases(),
    queryFn: () => analyticsDifareApi.getFases(),
  })
}

export function useDependientesAnalyticsDifare(filtro: DependientesFiltro = {}) {
  return useQuery({
    queryKey: KEYS.dependientes(filtro),
    queryFn: () => analyticsDifareApi.getDependientes(filtro),
  })
}

export function useTriviasAnalyticsDifare(fase?: number) {
  return useQuery({
    queryKey: KEYS.trivias(fase),
    queryFn: () => analyticsDifareApi.getTrivias({ fase }),
  })
}
